"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACLCheckboxes = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const backendImport_1 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="card card-body mb-4">
    <table id="access-table" class="table table-bordered">
      <thead class="thead-light">
        <tr>
          <th width="30%">${'acl.table.resource'.t()}</th>
          ${T.repeat(x => Object.entries(x.roles), T.html `<th class="text-center">
            <rws-tooltip text="${([actionKey]) => `acl_action_desc.${actionKey}`.t()}">
              ${([actionKey]) => `acl_action.${actionKey}`.t()}
            </rws-tooltip>
            <part-checkbox inline="true" ignore="true" :onChange="${([actionKey], c) => c.parent.checkAll.bind(c.parent)}" name="${([actionKey]) => actionKey}_all"></part-checkbox>
          </th>`)}
        </tr>
      </thead>
      <tbody>
        ${T.repeat(x => Object.entries(x.resources), T.html `
          <tr>
            <td>
              <rws-tooltip text="${(x) => `acl_resource_desc.${x[0]}`.t()}">
                ${(x) => `acl_resource.${x[0]}`.t()}
              </rws-tooltip>
            </td>
            ${T.repeat((x, c) => Object.entries(c.parent.roles), T.html `
              <td class="access-check">    
                <part-checkbox
                  class="form-part static"
                  size="30px"
                  :value="${(action, c) => c.parentContext.parent.isChecked(c.parent[1], action[1])}"
                  name="${(action, c) => `access.${c.parent[1]}.${action[1]}`}"
                  :disabled="${(action, c) => c.parentContext.parent.disabled}"
                ></part-checkbox>
              </td>
            `)}
          </tr>
        `)}
      </tbody>
    </table>
  </div>
</template>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
}

.access-check {
  text-align: center;
  width: 100px;
  padding: 30px !important;
}
.access-check part-checkbox {
  text-align: center;
}
.access-check part-checkbox input {
  position: static !important;
}

#access-table .table {
  margin-bottom: 0;
}
#access-table th {
  vertical-align: middle;
  text-align: center;
}
#access-table td {
  vertical-align: middle;
}`;
const shadowOptions = { "mode": "open" };
let ACLCheckboxes = class ACLCheckboxes extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.resources = {};
        this.roles = {};
        this.value = {};
        this.name = 'policyEntry';
        this.disabled = false;
        this.localValue = {};
    }
    connectedCallback() {
        super.connectedCallback();
        // Initialize local value from props
        this.localValue = { ...this.value };
        // Listen for checkbox changes
        this.on(events_1.inputEvents.changed, (event) => {
            const key = event.detail.fieldName;
            if (event.detail.element.type === 'checkbox' && key.startsWith('access.')) {
                const [prefix, resourceEnum, actionEnum] = key.split('.');
                const checked = event.detail.element.checked;
                // Convert enum values to short keys
                const resourceKey = resourceEnum;
                const actionKey = actionEnum;
                if (!this.localValue[resourceKey]) {
                    this.localValue[resourceKey] = [];
                }
                if (checked) {
                    if (!this.localValue[resourceKey].includes(actionKey)) {
                        this.localValue[resourceKey].push(actionKey);
                    }
                }
                else {
                    this.localValue[resourceKey] = this.localValue[resourceKey].filter((a) => a !== actionKey);
                }
                if (this.onACLChanged) {
                    this.onACLChanged(this.localValue);
                }
            }
        });
    }
    valueChanged() {
        this.localValue = { ...this.value };
    }
    getResourceKeyFromEnum(enumValue) {
        // Reverse mapping: enum value to short key
        for (const [key, value] of Object.entries(this.resources)) {
            if (value === enumValue) {
                return key;
            }
        }
        return enumValue.replace('res_', ''); // fallback
    }
    getActionKeyFromEnum(enumValue) {
        // Reverse mapping: enum value to short key
        for (const [key, value] of Object.entries(this.roles)) {
            if (value === enumValue) {
                return key;
            }
        }
        return enumValue.replace('role_', ''); // fallback
    }
    isChecked(resourceEnum, actionEnum) {
        const resourceKey = resourceEnum;
        const actionKey = actionEnum;
        return this.localValue && this.localValue[resourceKey] && this.localValue[resourceKey].includes(actionKey);
    }
    checkAll(event) {
        const target = event.target;
        const actionKey = backendImport_1.ACL.getActionEnumValue(target ? target.name.replace('_all', '') : '');
        const localValue = { ...this.localValue };
        const resources = Object.keys(this.resources);
        resources.forEach(resourceKey => {
            const resourceEnum = backendImport_1.ACL.getResourceEnumValue(resourceKey);
            if (!localValue[resourceEnum]) {
                localValue[resourceEnum] = [];
            }
            if (target.checked) {
                if (!localValue[resourceEnum].includes(actionKey)) {
                    localValue[resourceEnum].push(actionKey);
                }
            }
            else {
                localValue[resourceEnum] = localValue[resourceEnum].filter((a) => a !== actionKey);
            }
        });
        this.localValue = localValue;
        if (this.onACLChanged) {
            this.onACLChanged(this.localValue);
        }
    }
};
exports.ACLCheckboxes = ACLCheckboxes;
__decorate([
    client_1.attr,
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], ACLCheckboxes.prototype, "resources", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], ACLCheckboxes.prototype, "roles", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], ACLCheckboxes.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ACLCheckboxes.prototype, "name", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], ACLCheckboxes.prototype, "disabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IACLPolicyEntry !== "undefined" && backendImport_1.IACLPolicyEntry) === "function" ? _d : Object)
], ACLCheckboxes.prototype, "localValue", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], ACLCheckboxes.prototype, "onACLChanged", void 0);
exports.ACLCheckboxes = ACLCheckboxes = __decorate([
    (0, client_1.RWSView)('acl-checkboxes', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ACLCheckboxes);
ACLCheckboxes.defineComponent();
